import { render, staticRenderFns } from "./queryBookBorrowHistory.vue?vue&type=template&id=f596e328&"
import script from "./queryBookBorrowHistory.vue?vue&type=script&lang=js&"
export * from "./queryBookBorrowHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports